import React from 'react';
import './Assets/App.scss';
import ReactDOM from 'react-dom/client';
// import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { persistor, store } from './Redux/Store';
import { PersistGate } from 'redux-persist/integration/react';


// import "./Assets/css/style.css"
// import "./Assets/css/slick.min.css"
// import "./Assets/css/slick-theme.css"
// import "./Assets/css/owl.carousel.min.css"
// import "./Assets/css/m-custom-scrollbar.min.css"
// import "./Assets/css/magnific-popup.min.css"
// import "./Assets/css/lc_lightbox.css"
// import "./Assets/css/font-awesome.min.css"
// import "./Assets/css/font.css"
// import "./Assets/css/feather.css"
// import "./Assets/css/dropzone.css"
// import "./Assets/css/dataTables.bootstrap4.min.css"
// import "./Assets/css/bootstrap-slider.min.css"
// import "./Assets/css/bootstrap-select.min.css"
// import "./Assets/css/bootstrap4-toggle.min.css"
// import "./Assets/css/bootstrap.min.css"



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
